export const loadingStateTips = [
  'Try asking Copilot to plan before implementing',
  'Reference specific files to give Copilot better context',
  'You can ask Copilot to explain its approach before making changes',
  'Add a .github/agents.md file to customize Copilot for your repository',
  'Copilot can work on multiple tasks in parallel across different repos',
  'Use the Copilot CLI to start tasks from your terminal',
  'Ask Copilot to write tests for its own changes before finishing',
  "You can approve or reject Copilot's plan before it starts coding",
]
